export const STORAGE_KEY = 'onboarding_training_progress';
const START_MODAL_STORAGE_KEY = 'onboarding_training_start_modal_shown';

const getStorage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { answers: {}, completedSections: [] };
  } catch {
    return { answers: {}, completedSections: [] };
  }
};

const setStorage = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* empty */
  }
};

export const saveAnswer = (globalId, option) => {
  const data = getStorage();
  data.answers[globalId] = option;
  setStorage(data);
};

export const getAnswers = () => getStorage().answers;

export const saveCompletedSection = (part) => {
  const data = getStorage();
  if (!data.completedSections.includes(part)) {
    data.completedSections.push(part);
    setStorage(data);
  }
};

export const getCompletedSections = () => getStorage().completedSections;

export const clearTrainingProgress = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* empty */
  }
};

export const getStartModalShown = () => {
  try {
    const raw = localStorage.getItem(START_MODAL_STORAGE_KEY);
    return raw ? JSON.parse(raw) === true : false;
  } catch {
    return false;
  }
};

export const saveStartModalShown = () => {
  try {
    localStorage.setItem(START_MODAL_STORAGE_KEY, JSON.stringify(true));
  } catch {
    /* empty */
  }
};
